import { render, staticRenderFns } from "./GeneralNotificationModal.vue?vue&type=template&id=5446f0b9&scoped=true"
import script from "./GeneralNotificationModal.vue?vue&type=script&lang=js"
export * from "./GeneralNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./GeneralNotificationModal.vue?vue&type=style&index=0&id=5446f0b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5446f0b9",
  null
  
)

export default component.exports